<template>
  <div class="text-xl font-sans font-medium py-24 relative min-h-screen green-bkg"> 
    <!--Introduzione-->
    <div v-show="step === 1">
      <p class="px-8">
        {{ $t('Close to you, you have a person who causes you some difficulties or whom you have some problems dealing with. Click on one of the two buttons to continue:') }}
      </p>
      <div class="flex flex-col mt-4 p-8 w-full">
        <button
        @click="step = 2"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
        :class="{ done : active_el == 1 }">{{ $t('Identify') }}</button>
        
        <button
        v-if="active_el == 1"
        @click="step = 10"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow">{{ $t('Manage') }}</button>
        

        <button
        v-else
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow opacity-40">{{ $t('Manage') }}</button>
      </div>
      <!-- <span>Clicca su uno dei tasti per approfondire.</span> -->
    </div>

    <!--Identificare-->
      <div v-show="step === 2">
        <p class="px-8">
         {{ $t('The person we are looking for has more than one of the following characteristics:') }}
         </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 3">
        <p class="px-8">
          {{ $t("Often he/she generalizes the negative or negative news (e.g., 'Clients don't pay...'') or your negative behaviors (e.g., 'You are ALWAYS late'). The use of the word ALWAYS must be your wake-up call. Do you have a person close to you (professional or personal sphere) who occasionally behaves like this?") }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer1 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer1 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>


      <div v-show="step === 4">
        <p class="px-8">
          {{ $t('He/she often belittles or criticizes you or your work while very rarely seeing or talking about your positive talents.') }}<br>{{ $t('Do you have a person close to you (professional or personal sphere) who occasionally behaves like this?') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer2 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer2 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 5">
        <p class="px-8">
          {{ $t('She is rather suspicious and tends to see potential problems or conspiracies against her everywhere.') }} <br>{{ $t('Do you have a person close to you (professional or personal sphere) who occasionally behaves like this?') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer3 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer3 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 6">
        <p class="px-8">
          {{ $t('If you point out his/her shortcomings he/she gets angry, hurt or defensive but does not change the way she operates and is always ready to find an excuse or justification for what he/she does not do well. Do you have such a person close to you (professional or personal sphere)?') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer4 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer4 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 7">
        <p class="px-8">
         {{ $t('The people around him/her have many difficulties.') }}<br>{{ $t('Do you have such a person close to you (professional or personal sphere)?') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer5 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer5 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 8">
        <p class="px-8">
          {{ $t('That person is often a cause for concern to you.') }}<br> {{ $t('Do you have such a person close to you (professional or personal sphere)?') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer6 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
           {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer6 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black  rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 9">

        <div class="px-8 text-white flex flex-col">
          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('He/she generalizes the negative') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <svg v-if="answer1 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('He/she belittles or criticizes you') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer2 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>


          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Suspicious') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer3 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('He/she does not change way of operation') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer4 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('The people he/she is close to have difficulties') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer5 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('He/she is a cause for concern to you') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer6 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

        </div>


        <p class="p-8">
        {{ $t('People who possess more than one of the above characteristics should be managed with great caution as they are TOXIC to anyone who has to deal with them. You try to improve them, but very often they will make you worse.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 1, activate(1)" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

    <!--Gestire-->
      <div v-show="step === 10">
        <p class="px-8">
        {{ $t('If you have identified a toxic person around you, these may be good tips for dealing with them. If you can take some notes...') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 11">
        <p class="px-8">
          1. {{ $t('It is difficult to face someone when we have weaknesses towards him/her.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 12" >
        <p class="px-8">
          {{ $t('Is there anything true in the criticism, even if exaggerated and irrational, that this person places on you?') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 13">
        <p class="px-8">
          <!-- C’è qualcosa di non ottimale che <span class="underline">hai fatto tu</span> nei confronti di questa persona e che non stai mettendo a posto? -->
          {{ $t("Is there something not optimal that you did to this person that you're not solving?") }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 14">
        <p class="px-8">{{ $t('What could you do to address this weakness?') }}</p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>


      <div v-show="step === 15">
        <p class="px-8">
          2. {{ $t("If you react impulsively when this person attacks you, you usually end up feeling very bad and even more dependent on him/her. Learn to let his/her attacks roll off your back and change the subject when he/she talks about things that don't make you feel good. Try to win the war and not a battle.") }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 16">
        <p class="px-8">
          3. {{ $t("When the conversation falls on you, even if you are talking positively, quickly change the subject of the discussion. If you don't change the subject, you'll be criticized sooner or later.") }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 17">
        <p class="px-8">
          4. {{ $t("Never tell this person about your problems or things that concern you. He/she'll turn them against you, even if not immediately.") }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 18">
        <p class="px-8">5. {{ $t('If you really need to see her, for professional or personal reasons, try not to see her so often. Reducing meetings with him/her will make you feel better.') }}</p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 19">
        <p class="px-8">
          {{ $t('And if he/she really continues to make your life difficult, consider letting him/her go. You could feel much, much better') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next(), isComplete = true" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>


    <div v-if="isComplete == true && done[6] == 0" class="mx-8">
      <form @submit.prevent="submit">
      <audio autoplay>
        <source src="/sound/money.wav" type="audio/wav" />
      </audio>
      <ul class="flex flex-wrap justify-center">
        <li class="w-1/6">
          <img src="/img/osm-coin.png" alt="gem" />
        </li>
      </ul>
      <p class="p-8 text-center text-2xl text-white font-bold">
        {{ $t('Congratulations!') }}<br /> {{ $t('You have finished this improvement program!!!') }}<br />
        {{ $t("We've awarded you 0.5 OSM Coins!!!") }}      </p>
      <button
          type="submit"
          class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
        >
          fine
        </button>
      </form>
    </div>

    <div v-if="isComplete == true && done[6] == 1" class="p-8">
      <h5 class="text-left text-2xl text-white font-bold">
        {{ $t('Congratulations!') }}<br /> {{ $t('You have completed this improvement program again!!!') }}<br />
      </h5>
      <inertia-link :href="route('curricula')" class="inline-block text-white py-2 px-6 border-2 border-white rounded-xl mt-16">
        fine
      </inertia-link>
    </div>

    
  </div>
</template>

<script>
export default {
   props: ['done'],
  data() {
    return {
      step: 1,
      progress: 0,
      isComplete: false,
      active_el: 0,
      program_id: 7,
      answer1: 0,
      answer2: 0,
      answer3: 0,
      answer4: 0,
      answer5: 0,
      answer6: 0,
    };
  },
  methods: {
    prev() {
      this.step--;
      var stepValue = 10;
      this.progress = this.progress - stepValue;
    },
    next(progress) {
      this.step++;
      var stepValue = 10;
      this.progress = this.progress + stepValue;
    },
    activate:function(el){
        this.active_el = el;
    },
    submit() {
      const data = new FormData()
      data.append('program_id', this.program_id)

      this.$inertia.post(this.route('workout.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
  },
};
</script>

<style>
.done {
  background:#7ED321;
  font-weight:bold;
}

.green-bkg {
background: #36D096;
background: -webkit-linear-gradient(top right, #36D096, #1AAAAF);
background: -moz-linear-gradient(top right, #36D096, #1AAAAF);
background: linear-gradient(to bottom left, #36D096, #1AAAAF);
}
</style>